import React from "react";
import Button from "deltoid/core/Button";
import DomainStatusModal from "./DomainStatusModal";
import MobileDomainStatusModal from "./MobileDomainStatusModal";
import PropTypes from "prop-types";

import StatusForm from "./StatusForm";

const WebsiteStatus = () => {
  return (
    <DomainStatusModal
      heading="Looks like your domain is not yet active."
      subHeading="But we may be wrong. Tell us if your website domain is active or
not."
      imgSrc="../../../../assets/images/onboarding/domain-status-modal-graphic.svg"
      colHeading="Looking for professional web and app developers?"
      colSubHeading="Explore PayU Experts"
      colLink={process.env.EXPERTS_PAYU_HOST}
    >
      <StatusForm />
    </DomainStatusModal>
  );
};

const WebsiteActive = ({ handleClose }) => {
  return (
    <DomainStatusModal
      heading="Thank you for letting us know!"
      subHeading="You can proceed to complete your KYC."
      imgSrc="../../../../assets/images/onboarding/domain-status-modal-graphic.svg"
      colHeading="Looking for professional web and app developers?"
      colSubHeading="Explore PayU Experts"
      colLink={process.env.EXPERTS_PAYU_HOST}
    >
      {
        <Button
          type="DEFAULT"
          buttonType="submit"
          style={{
            height: "40px",
            borderRadius: "2px",
            background: "#18AF8B",
            alignItems: "center",
            padding: "8px 16px",
          }}
          onClick={handleClose}
        >
          Proceed to Next Step
        </Button>
      }
    </DomainStatusModal>
  );
};
const WebsiteInactive = ({ handleClose }) => {
  return (
    <DomainStatusModal
      heading="You can proceed to complete your KYC."
      subHeading="Please make sure you update your active domain details (from profile section) in order to integrate Payment Gateway on your website."
      imgSrc="../../../../assets/images/onboarding/domain-status-modal-graphic.svg"
      colHeading="Every business should have a robust & secure Website domain"
      colSubHeading="Get a Free Domain with GoDaddy®"
      colLink="https://in.godaddy.com/"
    >
      <Button
        type="DEFAULT"
        buttonType="submit"
        style={{
          height: "40px",
          borderRadius: "2px",
          background: "#18AF8B",
          alignItems: "center",
          padding: "8px 16px",
        }}
        onClick={handleClose}
      >
        Proceed to Next Step
      </Button>
    </DomainStatusModal>
  );
};
const MobileWebsiteStatus = () => {
  return (
    <MobileDomainStatusModal
      heading="Looks like your domain is not yet active."
      subHeading="But we may be wrong. Tell us if your website domain is active or
not."
      imgSrc="../../../../assets/images/onboarding/domain-status-modal-graphic.svg"
      colHeading="Looking for professional web and app developers?"
      colSubHeading="Explore PayU Experts"
      colLink={process.env.EXPERTS_PAYU_HOST}
    >
      <StatusForm />
    </MobileDomainStatusModal>
  );
};

const MobileWebsiteActive = ({ handleClose }) => {
  return (
    <MobileDomainStatusModal
      heading="Thank you for letting us know!"
      subHeading="You can proceed to complete your KYC."
      imgSrc="../../../../assets/images/onboarding/domain-status-modal-graphic.svg"
      colHeading="Looking for professional web and app developers?"
      colSubHeading="Explore PayU Experts"
      colLink={process.env.EXPERTS_PAYU_HOST}
    >
      {
        <Button
          type="DEFAULT"
          buttonType="submit"
          style={{
            height: "40px",
            borderRadius: "2px",
            background: "#18AF8B",
            alignItems: "center",
            padding: "8px 16px",
          }}
          onClick={handleClose}
        >
          Proceed to Next Step
        </Button>
      }
    </MobileDomainStatusModal>
  );
};
const MobileWebsiteInactive = ({ handleClose }) => {
  return (
    <MobileDomainStatusModal
      heading="You can proceed to complete your KYC."
      subHeading="Please make sure you update your active domain details (from profile section) in order to integrate Payment Gateway on your website."
      imgSrc="../../../../assets/images/onboarding/domain-status-modal-graphic.svg"
      colHeading="Every business should have a robust & secure Website domain"
      colSubHeading="Get a Free Domain with GoDaddy®"
      colLink="#"
    >
      <Button
        type="DEFAULT"
        buttonType="submit"
        style={{
          height: "40px",
          borderRadius: "2px",
          background: "#18AF8B",
          alignItems: "center",
          padding: "8px 16px",
        }}
        onClick={handleClose}
      >
        Proceed to Next Step
      </Button>
    </MobileDomainStatusModal>
  );
};

WebsiteActive.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

WebsiteActive.defaultProps = {
  handleClose: () => { },
};

WebsiteInactive.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

WebsiteInactive.defaultProps = {
  handleClose: () => { },
};

export default {
  WebsiteStatus,
  WebsiteActive,
  WebsiteInactive,
  MobileWebsiteStatus,
  MobileWebsiteActive,
  MobileWebsiteInactive,
};
